import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AcqStatus, AcqType } from '@/types.ts'
import { DefaultFiltersState } from '@/stores'

import { SetFilterValue } from '../shared.ts'

export interface AcquiringTableState extends DefaultFiltersState {
  type?: AcqType
  state?: AcqStatus | 'ALL'
  clientFio?: string
  // YYYY-MM-DD
  dateFrom?: string
  // YYYY-MM-DD
  dateTo?: string
}

const initialState: AcquiringTableState = {
  type: undefined,
  clientFio: undefined,
  dateTo: undefined,
  dateFrom: undefined,
  state: 'ALL',
  page: 0,
  showCount: 10,
}

const acquiringPaymentsSlice = createSlice({
  name: 'acquiringPayments',
  initialState,
  selectors: {
    filters: (state) => ({ page: state.page, showCount: state.showCount, sort: state.sort }),
    paramsForRequest: (state) => ({
      dateTo: state.dateTo,
      dateFrom: state.dateFrom,
      state: state.state,
      clientFio: state.clientFio,
    }),
    resettableStateFilters: (state, filters: (keyof AcquiringTableState)[]) => filters.map((e) => state[e]),
  },
  reducers: {
    setFilter: (state, action: PayloadAction<SetFilterValue<AcquiringTableState>>) => {
      return {
        ...state,
        page: action.payload.filterKey !== 'page' ? 0 : state.page,
        [action.payload.filterKey]: action.payload.filterValue,
      }
    },
    resetFilters: (state, action: PayloadAction<(keyof AcquiringTableState)[]>) => {
      const patch = Object.fromEntries(action.payload.map((key) => [key, initialState[key]]))
      return { ...state, ...patch }
    },
  },
})

export const {
  reducer: acquiringPaymentsReducer,
  selectors: acquiringPaymentSelectors,
  actions: acquiringPaymentsActions,
} = acquiringPaymentsSlice
